export enum MasterDataTypes {
    Master = "MasterData",
    Referential = "Referential",
    Hierarchy = "Hierarchy",
}
